import { render, staticRenderFns } from "./RecruitInfo.vue?vue&type=template&id=3568bb5f&scoped=true&"
import script from "./RecruitInfo.vue?vue&type=script&lang=js&"
export * from "./RecruitInfo.vue?vue&type=script&lang=js&"
import style0 from "./RecruitInfo.vue?vue&type=style&index=0&id=3568bb5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3568bb5f",
  null
  
)

export default component.exports